import { Injectable, inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import {
  GlobalState,
  GlobalStateService,
} from "../services/global-state.service";

@Injectable({
  providedIn: "root",
})
export class QueryParamGuard {
  private router = inject(Router);
  private globalStateSvc = inject(GlobalStateService);

  canActivate(
    route: ActivatedRouteSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const params = route.queryParams;

    if (environment.production) {
      const state: GlobalState = {
        custNum: params["custNum"],
        shipToNum: params["shipToNum"],
        orderNum: params["orderNum"],
        company: params["comp"],
        partNum: params["partNum"],
        lang: params["lang"] ? params["lang"] : null,
        useLossFactor: params["useLossFactor"]
          ? Boolean(JSON.parse(params["useLossFactor"]))
          : false,
        quoteType: params["quoteType"] ? params["quoteType"] : null,
        quoteId: params["quoteId"] ? params["quoteId"] : null,
        quoteLineId: params["quoteLineId"] ? params["quoteLineId"] : null,
      };
      this.globalStateSvc.updateQueryParams(state);
    } else {
      const state: GlobalState = {
        custNum: params["custNum"] ? params["custNum"] : 438,
        shipToNum: params["shipToNum"] ? params["shipToNum"] : "",
        orderNum: params["orderNum"] ? params["orderNum"] : 0,
        company: params["comp"] ? params["comp"] : "MCAD",
        partNum: params["partNum"] ? params["partNum"] : "",
        lang: params["lang"] ? params["lang"] : null,
        useLossFactor: params["useLossFactor"]
          ? Boolean(JSON.parse(params["useLossFactor"]))
          : false,
        quoteType: params["quoteType"] ? params["quoteType"] : null,
        quoteId: params["quoteId"] ? params["quoteId"] : null,
        quoteLineId: params["quoteLineId"] ? params["quoteLineId"] : null,
      };
      this.globalStateSvc.updateQueryParams(state);
    }

    if (!this.globalStateSvc.isQueryStringValid()) {
      this.router.navigate(["error/400"], {
        state: { message: "Invalid Query String" },
      });
      return false;
    }
    return true;
  }
}
